'use client'

import { UnstyledModal } from '@/components/ui/general-modal'
import { cn } from '@/utils/styles/cn'
import { X } from 'lucide-react'

function getYouTubeEmbedUrl(videoId: string) {
    const params = new URLSearchParams({
        autoplay: '1',
        rel: '0',
        modestbranding: '1',
    })
    return `https://www.youtube.com/embed/${videoId}?${params.toString()}`
}

export interface IYouTubeVideoModalProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    videoId: string
    title: string
    className?: string
}

export function AgentHomeEmptyYoutubeVideoModal({ open, onOpenChange, videoId, title, className }: IYouTubeVideoModalProps) {
    return (
        <UnstyledModal
            open={open}
            onOpenChange={onOpenChange}
            title={title}
            className={cn('bg-black/95 border-0 shadow-2xl p-0 rounded-2xl md:rounded-3xl overflow-hidden', className)}
            overlayClassName="bg-black/80"
            dialogContentProps={{
                className: '!w-auto !max-w-none !p-0 !border-0 !bg-transparent shadow-none',
                overlayContent: (
                    <button
                        type="button"
                        onClick={() => onOpenChange(false)}
                        aria-label="Close"
                        className="fixed right-4 top-4 z-60 flex h-8 w-8 items-center justify-center rounded-full bg-white/15 text-white/80 hover:bg-white/25 hover:text-white transition-colors"
                    >
                        <X className="h-4 w-4" />
                    </button>
                ),
            }}
        >
            <div className="w-[90vw] md:w-[min(48vw,900px)] bg-black rounded-2xl md:rounded-3xl overflow-hidden">
                <iframe
                    src={open ? getYouTubeEmbedUrl(videoId) : undefined}
                    title={title}
                    className="block w-full aspect-video border-0 bg-black"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                />
            </div>
        </UnstyledModal>
    )
}
